module.exports = __webpack_public_path__ + "static/media/money-fly.a035a5d2.png";